import React from 'react';
import { DraftReportList } from '../draft-report/DraftReportList';
import { DraftReportSearch } from '../draft-report/DraftReportSearch';
import {
  DraftReportSearchOptions,
  DraftReportQueryParam,
  DraftReportResponseBody,
} from '@core/@models/DraftReportModel';
import { SearchProvider } from '@contexts/SearchProvider';
import { SortDirection } from '@core/@models/PaginationModal';

export const SentReport: React.FC = () => {
  const initialParam: DraftReportQueryParam = {
    companyId: undefined,
    templateId: undefined,
    periodId: null,
    statusId: null,
    begin: null,
    end: null,
    sort: `updateDate,${SortDirection.DESC}`,
    size: 15,
    page: 1,
  };

  return (
    <SearchProvider<DraftReportQueryParam, DraftReportSearchOptions>
      initialParam={initialParam}
    >
      <DraftReportSearch />
      <DraftReportList<DraftReportResponseBody> />
    </SearchProvider>
  );
};
